"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debug = exports.debuggers = void 0;
const debug_1 = __importDefault(require("debug"));
const Sentry = __importStar(require("@sentry/react"));
const hooks_1 = require("../hooks");
exports.debuggers = {};
exports.debug = {
  namespace: "reactify-search",
  log: function (namespace, formatter) {
    if (!exports.debuggers[namespace]) {
      exports.debuggers[namespace] = (0, debug_1.default)(`${exports.debug.namespace}:${namespace}`);
    }
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    exports.debuggers[namespace](formatter, ...args);
  },
  breadcrumb: breadcrumb => {
    Sentry.addBreadcrumb(Object.assign(Object.assign({
      level: "debug",
      type: "query"
    }, breadcrumb), {
      category: `${exports.debug.namespace}:${breadcrumb.category}`
    }));
  },
  hook: hooks_1.useDebugger
};